import { FC } from 'react';
import styles from './CheckoutInlineText.module.scss';

interface ITextInlineProps {
  text: string;
  customClass?: string;
}

export const CheckoutInlineText: FC<ITextInlineProps> = ({ text, customClass }: ITextInlineProps) => (
  <p className={`${styles['inline-text']} ${customClass}`} data-testid="inline-text">
    {text}
  </p>
);

export default CheckoutInlineText;
